import { PinIcon } from "./PinIcon";

export default PinIcon;
